import { render, staticRenderFns } from "./planRecommendDetails.vue?vue&type=template&id=70bae71c&scoped=true"
import script from "./planRecommendDetails.vue?vue&type=script&lang=js"
export * from "./planRecommendDetails.vue?vue&type=script&lang=js"
import style0 from "./planRecommendDetails.vue?vue&type=style&index=0&id=70bae71c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bae71c",
  null
  
)

export default component.exports